/**
 * Lecture de l'état des chambres pour la réception : règles partagées entre le
 * widget web « Housekeeping » et le module mobile « État des chambres ».
 * Module feuille (aucun import) : le mobile peut l'atteindre.
 */

export interface CompteursChambres {
    aFaire: number;
    enCours: number;
    aControler: number;
    pretes: number;
}

/** Les quatre étapes qui intéressent la réception, depuis `rooms_by_status`. */
export function compteursChambres(parStatut: Record<string, number> | undefined): CompteursChambres {
    const n = (statut: string) => Number(parStatut?.[statut] ?? 0);
    return {
        aFaire: n('free_dirty'),
        enCours: n('cleaning'),
        aControler: n('to_inspect'),
        pretes: n('free_clean') + n('inspected'),
    };
}

/**
 * « Arrivées prêtes » en retard : l'heure cible de l'hôtel est passée et toutes les
 * chambres attendues ne sont pas prêtes. C'est la règle du rouge, au web comme au mobile.
 */
export function arriveesEnRetard(ratioPretes: number, heureCiblePassee: boolean): boolean {
    return heureCiblePassee && ratioPretes < 1;
}
